import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GlobalNotificationBanner, GlobalNotificationBannerService } from './global-notification-banner.service';

@Component({
  selector: 'td-wb-global-notification-banner',
  templateUrl: 'global-notification-banner.component.html',
  styleUrls: ['global-notification-banner.component.scss'],
  imports: [
    NgComponentOutlet
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalNotificationBannerComponent {
  banners: Array<GlobalNotificationBanner>;

  constructor(private globalNotificationBannerService: GlobalNotificationBannerService,
              private changeDetectorRef: ChangeDetectorRef) {
    this.globalNotificationBannerService.currentlyDisplayedBanners
      .pipe(takeUntilDestroyed())
      .subscribe((banners: Array<GlobalNotificationBanner>): void => {
        this.banners = banners;
        this.changeDetectorRef.markForCheck();
      });
  }
}
